<template>
  <div
    v-if="isVisible"
    class="p-floating-give-point-button"
    :style="{ '--site-color': colorCode }"
  >
    <button
      type="button"
      class="p-floating-give-point-button__close"
      aria-label="閉じる"
      @click="close"
    >
      <IconBase
        :width="16"
        :height="16"
        view-box="0 0 16 16"
        icon-name="閉じる"
      >
        <IconCancel />
      </IconBase>
    </button>
    <a :href="url" class="p-floating-give-point-button__link">
      <IconBase
        class="p-floating-give-point-button__icon"
        :width="20"
        :height="20"
        view-box="3 4 18 17"
        icon-name="ポイントを贈る"
      >
        <IconPresent />
      </IconBase>
      <span class="p-floating-give-point-button__label">
        <span data-translate-skip>{{ pointName }}</span>を贈る
      </span>
    </a>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { mapState } from "vuex";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconCancel from "@/common/components/icons/IconCancel.vue";
import IconPresent from "@/common/components/icons/IconPresent.vue";
import commons from "@/common/store/modules/commons";
import CONST_DATA from "@/general/mixins/const/constData";

@Options({
  components: {
    IconBase,
    IconCancel,
    IconPresent
  },
  computed: {
    ...mapState({
      storeColorCode: () => commons.colorCode,
      storePointName: () => commons.unit.point
    })
  }
})
export default class FloatingGivePointButton extends Vue {
  isClosed = false;
  storeColorCode!: string;
  storePointName!: string;

  get colorCode() {
    return this.storeColorCode;
  }

  get pointName() {
    return this.storePointName;
  }

  get url() {
    return CONST_DATA.SITE_MAP.THANKS_POINT_GIVE_THANKS_POINT;
  }

  get isGroupBudget() {
    return commons?.userInfo.groupBudgetMode;
  }

  get thanksFunctionEnabled() {
    return commons.thanksFunctionEnabled;
  }

  get isVisible() {
    return (
      !this.isClosed &&
      this.thanksFunctionEnabled &&
      this.isGroupBudget === false
    );
  }

  close() {
    this.isClosed = true;
  }
}
</script>

<style lang="scss" scoped>
.p-floating-give-point-button {
  position: fixed;
  right: rem(32);
  bottom: rem(32);
  z-index: 1000;

  &__link {
    display: flex;
    gap: rem(8);
    align-items: center;
    height: rem(56);
    padding: rem(8) rem(16);
    color: $common-white;
    background-color: var(--site-color);
    border: px(1) solid $common-white;
    border-radius: rem(28);
    box-shadow: 0 0 rem(4) rgba($common-black, 0.1);
  }

  &__icon {
    flex-shrink: 0;
  }

  &__label {
    color: inherit;
    font-size: rem(16);
    font-weight: bold;
    line-height: 1.25;
    white-space: nowrap;
    font-feature-settings: "pwid" 1, "palt" 1;
  }

  &__close {
    position: absolute;
    top: rem(-3);
    right: rem(-3);
    z-index: 1;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    width: rem(22);
    height: rem(22);
    padding: rem(3);
    color: var(--site-color);
    background-color: $common-white;
    border: none;
    border-radius: 50%;
    box-shadow: 0 0 rem(4) rgba($common-black, 0.1);
    cursor: pointer;
  }

  @include sp {
    right: rem(16);
    bottom: rem(16);
    max-width: calc(100vw - #{rem(32)});

    &__link {
      gap: rem(8);
      justify-content: center;
      height: rem(44);
      padding-top: rem(6);
      padding-bottom: rem(6);
      border-radius: rem(22);
    }

    &__icon {
      width: rem(18);
      height: rem(18);
    }

    &__label {
      font-size: rem(14);
    }

    &__close {
      top: rem(-5);
      right: rem(-5);
    }
  }
}
</style>
